<template>
  <div
    :class="getVariant"
    class="input-text"
  >
    <textarea
      :id="id"
      :class="{ 'has-text' : hasText }"
      :value="value"
      :type="type"
      :name="id"
      :readonly="disabled"
      rows="10"
      placeholder=" "
      autocomplete="off"
      required
      @input="updateValue($event.target.value)"
    />

    <label :for="id">
      {{ $t(label) }}
    </label>
  </div>
</template>

<script>
import uid from '@/mixins/uid';
import variant from '@/mixins/variant';

export default {
  name: 'InputText',

  mixins: [uid, variant],

  props: {
    // v-model accepts a value prop
    value: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: 'text'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: ''
    },

    variant: {
      type: String,
      default: ''
    }
  },

  computed: {
    hasText() {
      return this.value !== '';
    }
  },

  methods: {
    updateValue(value) {
      // Emit the number value through the input event
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/input/input-text-view.scss"></style>



// WEBPACK FOOTER //
// input-text-view.vue